import {
  useActivateSavedFilterMutation,
  useDeactivateSavedFilterMutation,
} from '@/graphql/generated/hooks'
import { useAppDispatch } from '@/redux/hooks'
import { setActiveFilter } from '@/redux/incidents/incidentsSlice'

import { SavedFilterI } from '../types/generic'

export const useActivateFilter = () => {
  const dispatch = useAppDispatch()
  const [activateSavedFilter, { loading: isActivateLoading }] =
    useActivateSavedFilterMutation()

  const [deactivateSavedFilter, { loading: isDeactivateLoading }] =
    useDeactivateSavedFilterMutation()

  const onActivateFilter = async (filter: SavedFilterI) => {
    await activateSavedFilter({
      variables: {
        id: filter.id,
      },
      refetchQueries: ['SavedIncidentsFilters', 'ActiveIncidentsFilter'],
    })
  }

  const onDeactivateFilter = async (filter: SavedFilterI) => {
    await deactivateSavedFilter({
      variables: {
        id: filter.id,
      },
      refetchQueries: ['SavedIncidentsFilters', 'ActiveIncidentsFilter'],
    })

    dispatch(setActiveFilter(null))
  }

  return {
    isActivateLoading,
    isDeactivateLoading,
    onActivateFilter,
    onDeactivateFilter,
  }
}
